export enum SignatureSecurityState {
  InvalidRequest = -1,
  Inactive = 0,
  AllowAccess = 1,
  Verified = 2,
  Rejected = 3,
  Completed = 4,
  DenyAccessUserUnverified = 5,
  DenyAccessExpired = 6,
  AllowAccessCode = 7,
}
